<template>
  <footer class="footer">
    <nav class="footer__navigation">
      <p class="footer__navigation__static">
        &copy; 2020 ConfCloud. Preise inkl. 19 % USt. Ggf. zzgl. Setupgebühr.
      </p>
      <!--<router-link to="/hilfe" class="footer__navigation__link">Hilfe</router-link>-->
      <a href="mailto:info@confcloud.de" class="footer__navigation__link"
        >Kontakt</a
      >
      <router-link to="/rechtliches/impressum" class="footer__navigation__link"
        >Impressum</router-link
      >
      <router-link
        to="/rechtliches/datenschutz"
        class="footer__navigation__link"
        >Datenschutz</router-link
      >
      <router-link
        to="/rechtliches/system-policies"
        class="footer__navigation__link"
        >System Policies</router-link
      >
      <router-link to="/rechtliches/agb" class="footer__navigation__link"
        >AGB</router-link
      >
    </nav>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped lang="scss">
.footer {
  padding: $footerVPadding 0;
  margin-top: $footerMarginTop;

  background: rgba(gray, 0.1);

  &__static {
    text-align: center;
    margin: $footerMarginTop 0 0;
    font-size: 0.8em;
  }

  &__navigation {
    display: flex;
    align-items: center;

    @include container;

    &__static {
      margin-right: auto;
      opacity: 0.75;
    }
    &__link {
      text-decoration: none;
      margin-left: 1rem;
      color: $text;
      font-weight: 400;

      &:hover,
      &:focus {
        color: $primary;
      }
    }
  }
}
</style>
